module.exports = __webpack_public_path__ + "img/39_47.6711a9fb.png";